// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GetPortalConfigurationResponseModel } from './getPortalConfigurationResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PorticoPorticoGetPortalConfigurationDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': GetPortalConfigurationResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PorticoPorticoGetPortalConfigurationDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "GetPortalConfigurationResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return PorticoPorticoGetPortalConfigurationDefaultResponse.attributeTypeMap;
    }
}
